/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import ReactTable from 'react-table'
import createTable from 'react-table-hoc-fixed-columns'
// import "react-table/react-table.css";
import moment from 'moment'

import CSVExportModal from '../CSVExportModal'
// import profile_avatar from "../../../assets/images/mock/StockProfilePic.png";

const ReactTableFixedColumns = createTable(ReactTable)

class AdminCoachEngagementTable extends Component {
  state = {
    showModal: false,
    dataLoader: false,
    data: [],
  }

  get headers() {
    const { t } = this.props
    return [
      { label: t('common.golf.score'), key: 'score' },
      { label: t('common.field.firstName'), key: 'firstname' },
      { label: t('common.field.lastName'), key: 'lastname' },
      { label: t('reports.common.community'), key: 'community' },
      { label: t('common.field.email'), key: 'email' },
      { label: t('reports.adminCoachEngagement.phone'), key: 'phone' },
      { label: t('reports.adminCoachEngagement.lastLogin'), key: 'lastlogin' },
      {
        label: t('reports.adminCoachEngagement.communityActivityLast30DaysCsv'),
        key: 'communityactivity',
      },
      {
        label: t('reports.adminCoachEngagement.activeGolfers'),
        key: 'activegolfers',
      },
      { label: t('reports.adminCoachEngagement.golfers'), key: 'golfers' },
      { label: t('reports.adminCoachEngagement.plays'), key: 'plays' },
      { label: t('reports.adminCoachEngagement.practices'), key: 'practices' },
      { label: t('reports.adminCoachEngagement.social'), key: 'social' },
      { label: t('reports.adminCoachEngagement.goals'), key: 'goals' },
      {
        label: t('reports.adminCoachEngagement.privateGoalsIssued'),
        key: 'privategoals',
      },
      {
        label: t('reports.adminCoachEngagement.completedExpressTraining'),
        key: 'expresstraining',
      },
      { label: t('reports.adminCoachEngagement.programs'), key: 'programs' },
      { label: t('reports.adminCoachEngagement.events'), key: 'events' },
      {
        label: t('reports.adminCoachEngagement.announcements'),
        key: 'announcements',
      },
      { label: t('reports.adminCoachEngagement.likes'), key: 'likes' },
      { label: t('reports.adminCoachEngagement.comments'), key: 'comments' },
    ]
  }

  toggleModal = data => {
    this.setState({
      showModal: !this.state.showModal,
      data: data ? data : [],
    })
  }

  createData = () => {
    const { data } = this.props

    const tempData = []
    this.setState({ dataLoader: true })
    if (data.length > 0) {
      data.map(d => {
        const score = d.engagement_score.value
        const firstname = d.coach.first_name
        const lastname = d.coach.last_name
        const community = d.community.name
        const email = d.coach.email
        const phone = d.coach.phone_prefix && d.coach.phone ? `${d.coach.phone_prefix}${d.coach.phone}` : d.coach.phone || ''
        const lastlogin = d.last_login_date.value
        const communityactivity = d.month_activity_count.value
        const activegolfers = d.active_golfer_count.value
        const golfers = d.golfer_count.value
        const plays = d.activity_play_count.value
        const practices = d.activity_train_count.value
        const social = d.activity_social_count.value
        const goals = d.activity_goal_count.value
        const privategoals = d.private_goal_count.value
        const expresstraining = d.completed_express_training.value
        const programs = d.programs_count.value
        const events = d.events_count.value
        const announcements = d.announcements_count.value
        const likes = d.likes_count.value
        const comments = d.comments_count.value

        tempData.push({
          score,
          firstname,
          lastname,
          community,
          email,
          phone,
          lastlogin: lastlogin ? moment(lastlogin).fromNow() : '---',
          communityactivity,
          activegolfers,
          golfers,
          plays,
          practices,
          social,
          goals,
          privategoals,
          expresstraining,
          programs,
          events,
          announcements,
          likes,
          comments,
        })
      })
    }

    this.toggleModal(tempData)
  }

  getColor = color => {
    switch (color) {
      case 'red':
        return '#ed213a'
      case 'yellow':
        return '#fddb10'
      case 'green':
        return '#33d9b2'
      default:
        return ''
    }
  }

  renderEngagementTableCell = props => (
    <div
      className='number'
      style={{
        backgroundColor: `${this.getColor(props.value.score.color)}`,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>
        {props.value ? `${props.value.value}%` : '---'}
      </div>
    </div>
  )

  renderTableCell = props => (
    <div
      className='number'
      style={{
        backgroundColor: `${this.getColor(props.value.score.color)}`,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>
        {props.value ? props.value.value : '---'}
      </div>
    </div>
  )

  renderCoachTableCell = props => (
    <div
      className='number'
      style={{
        backgroundColor: '',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>
        {props.value.first_name} {props.value.last_name}
      </div>
    </div>
  )

  renderLastLoginTableCell = props => (
    <div
      className='number'
      style={{
        backgroundColor: `${this.getColor(props.value.score.color)}`,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>
        {props.value && props.value.value
          ? moment(props.value.value).fromNow()
          : '---'}
      </div>
    </div>
  )

  renderBasicTableCell = props => (
    <div
      className='number'
      style={{
        backgroundColor: '',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>{props.value}</div>
    </div>
  )

  renderTable = () => {
    const { loader, data, fetchData, pages, t } = this.props
    const columns = [
      {
        Header: t('common.golf.score'),
        accessor: 'engagement_score',
        sortable: false,
        style: { padding: 0 },
        Cell: props => this.renderEngagementTableCell(props),
        fixed: true,
      },
      {
        Header: t('common.field.firstName'),
        accessor: 'coach.first_name',
        Cell: props => this.renderBasicTableCell(props),
        fixed: true,
      },
      {
        Header: t('common.field.lastName'),
        accessor: 'coach.last_name',
        Cell: props => this.renderBasicTableCell(props),
        fixed: true,
      },
      {
        Header: t('reports.common.community'),
        accessor: 'community.name',
        sortable: false,
        Cell: props => this.renderBasicTableCell(props),
      },
      {
        Header: t('common.field.email'),
        accessor: 'coach.email',
        Cell: props => this.renderBasicTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.phone'),
        accessor: 'coach.phone',
        sortable: false,
        Cell: props => this.renderBasicTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.lastLogin'),
        accessor: 'last_login_date',
        style: { padding: 0 },
        Cell: props => this.renderLastLoginTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.communityActivityLast30Days'),
        accessor: 'month_activity_count',
        sortable: false,
        style: { padding: 0 },
        Cell: props => this.renderTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.activeGolfers'),
        accessor: 'active_golfer_count',
        sortable: false,
        style: { padding: 0 },
        Cell: props => this.renderTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.golfers'),
        accessor: 'golfer_count',
        sortable: false,
        style: { padding: 0 },
        Cell: props => this.renderTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.plays'),
        accessor: 'activity_play_count',
        sortable: false,
        style: { padding: 0 },
        Cell: props => this.renderTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.practices'),
        accessor: 'activity_train_count',
        sortable: false,
        style: { padding: 0 },
        Cell: props => this.renderTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.social'),
        accessor: 'activity_social_count',
        sortable: false,
        style: { padding: 0 },
        Cell: props => this.renderTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.goals'),
        accessor: 'activity_goal_count',
        sortable: false,
        style: { padding: 0 },
        Cell: props => this.renderTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.privateGoalsIssued'),
        accessor: 'private_goal_count',
        sortable: false,
        style: { padding: 0 },
        Cell: props => this.renderTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.completedExpressTraining'),
        accessor: 'completed_express_training',
        sortable: false,
        style: { padding: 0 },
        Cell: props => this.renderTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.programs'),
        accessor: 'programs_count',
        sortable: false,
        style: { padding: 0 },
        Cell: props => this.renderTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.events'),
        accessor: 'events_count',
        sortable: false,
        style: { padding: 0 },
        Cell: props => this.renderTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.announcements'),
        accessor: 'announcements_count',
        sortable: false,
        style: { padding: 0 },
        Cell: props => this.renderTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.likes'),
        accessor: 'likes_count',
        sortable: false,
        style: { padding: 0 },
        Cell: props => this.renderTableCell(props),
      },
      {
        Header: t('reports.adminCoachEngagement.comments'),
        accessor: 'comments_count',
        sortable: false,
        style: { padding: 0 },
        Cell: props => this.renderTableCell(props),
      },
    ]

    return (
      <div className='container my-5 animated fadeIn'>
        <div className='row mb-5 d-flex align-items-center'>
          <div className='col-md-8'>
            <h2>{this.props.title}</h2>
          </div>
          <div className='col-md-4'>
            <button
              className='btn btn-sm btn-block'
              onClick={() => this.props.goBack()}
            >
              <i
                className='fa fa-arrow-left text-white mr-1'
                aria-hidden='true'
              />{' '}
              {t('reports.common.viewAnotherReport')}
            </button>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <ReactTableFixedColumns
              data={!loader ? data : []}
              columns={columns}
              pages={pages}
              pageSizeOptions={[5, 10, 20, 25, 50]}
              defaultPageSize={10}
              loading={loader}
              loadingText={t('reports.common.loadingReport')}
              noDataText={loader ? '' : t('reports.common.noDataFound')}
              manual
              onFetchData={(state, instance) =>
                fetchData(state, instance, 'coach_engagement')
              }
            />
          </div>
        </div>
        <button onClick={this.createData} className='mt-3 btn btn-success'>
          {t('reports.common.exportAsCsv')}
        </button>
      </div>
    )
  }

  render() {
    const { showModal } = this.state
    const { t } = this.props
    return (
      <div>
        {this.renderTable()}
        {showModal && (
          <CSVExportModal
            headers={this.headers}
            data={this.state.data}
            showModal={this.state.showModal}
            toggleModal={this.toggleModal}
            reportType={t('reports.adminCoachEngagement.reportType')}
            filename={'coach-engagement-report.csv'}
          />
        )}
      </div>
    )
  }
}

export default withTranslation()(AdminCoachEngagementTable)
